import { render, staticRenderFns } from "./imgShow.vue?vue&type=template&id=e828d176&scoped=true&"
import script from "./imgShow.vue?vue&type=script&lang=js&"
export * from "./imgShow.vue?vue&type=script&lang=js&"
import style0 from "./imgShow.vue?vue&type=style&index=0&id=e828d176&prod&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e828d176",
  null
  
)

export default component.exports